import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from "../../Components/Footer"
import Navbar from "../../Components/Navbar"

function Firsttheme({ get_data }){
const navigate = useNavigate();
    const [cart, setCart] = useState([]);
    const [visibleCategories, setVisibleCategories] = useState(12);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return(
        <>
            <style>{`
        :root {
            --primary: #850C85;
            --secondary: #ffffff;
            --text-dark: #333333;
            --text-light: #555555;
            --bg-light: #f9f9f9;
            --border: #D9D9D9;
        }

        body {
            font-family: 'Inter', sans-serif;
            background-color: var(--bg-light);
            color: var(--text-dark);
            margin: 0;
            padding: 0;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 16px;
        }

        .hero-banner {
            height: 500px;
            background-size: cover;
            background-position: center;
            border-radius: 12px;
            margin-top: 80px;
        }

        @media (min-width: 768px) {
            .hero-banner {
                height: 600px;
                margin-top: 16px;
            }
        }

        .main-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 24px;
            margin-top: 40px;
            margin-bottom: 40px;
        }

        @media (min-width: 768px) {
            .main-grid {
                grid-template-columns: 2fr 1fr;
            }
        }

        .card {
            background: var(--secondary);
            border: 1px solid var(--border);
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 24px;
        }

        .section-title {
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 16px;
            color: var(--text-dark);
        }

        .info-row {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 8px;
        }

        .info-row img {
            width: 24px;
            height: 24px;
        }

        .service-list {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
        }

        .service-tag {
            background: #f3e8f3;
            color: var(--primary);
            padding: 6px 12px;
            border-radius: 20px;
            font-size: 0.9rem;
            font-weight: 500;
        }

        .product-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            gap: 16px;
            margin-top: 16px;
        }

        .product-card {
            border: 1px solid #eee;
            border-radius: 8px;
            overflow: hidden;
            transition: transform 0.2s;
        }

        .product-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

        .product-img {
            height: 150px;
            width: 100%;
            object-fit: cover;
        }

        .product-info {
            padding: 12px;
        }

        .btn-primary {
            background: var(--primary);
            color: white;
            padding: 10px 20px;
            border-radius: 8px;
            border: none;
            font-weight: 600;
            cursor: pointer;
            transition: background 0.3s;
        }

        .btn-primary:hover {
            background: #6a096a;
        }
            `}</style>
            
            <Navbar service_name={get_data.service_name} />

            <div className="container">
                <div 
                    className="hero-banner" 
                    style={{ backgroundImage: `url(${get_data.featured_image && get_data.featured_image.startsWith('http') ? get_data.featured_image : 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=1200' })` }}
                ></div>

                <div className="main-grid">
                    <div className="left-col">
                        <div className="card">
                            <h2 className="section-title">About {get_data.service_name}</h2>
                            <p style={{lineHeight: '1.6', color: 'var(--text-light)', marginBottom: '24px'}}>
                                {get_data.description || `Welcome to ${get_data.service_name}. We are dedicated to providing the best service in the industry. Our team of experts is here to help you with all your needs.`}
                            </p>

                            <h2 className="section-title">Property Location</h2>
                            <div className="info-row">
                                <img src="/assets/images/images/location.png" alt="Location" />
                                <p style={{color: 'var(--text-light)'}}>{get_data.service_address}</p>
                            </div>
                        </div>

                        <div className="card" id="services">
                            <h2 className="section-title">Services & Categories</h2>
                            <div className="service-list">
                                {get_data.all_categories && get_data.all_categories.length > 0 ? (
                                    <>
                                        {get_data.all_categories.slice(0, visibleCategories).map((cat, index) => (
                                            <span key={index} className="service-tag">{cat.name}</span>
                                        ))}
                                        {get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                                            <div style={{textAlign: 'center', marginTop: '40px', width: '100%'}}>
                                                <button 
                                                    onClick={() => setVisibleCategories(prev => prev + 6)} 
                                                    className="btn"
                                                >
                                                    Show More
                                                </button>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <p>No specific categories listed.</p>
                                )}
                            </div>
                        </div>

                        <div className="card" id="products">
                            <h2 className="section-title">Our Offerings</h2>
                            <div className="product-grid">
                                {get_data.product_services && get_data.product_services.map((item, index) => (
                                    <div className="product-card" key={index}>
                                        {item.featured_image ? (<img 
                                            src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                            alt={item.service_name}
                                            className="product-img"
                                        />) : (<div className="product-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                                        <div className="product-info">
                                            <h3 style={{fontSize: '1rem', fontWeight: 'bold', marginBottom: '4px'}}>{item.service_name}</h3>
                                            {item.price && <p style={{color: 'var(--primary)', fontWeight: 'bold', marginBottom: '8px'}}>₹{item.price}</p>}
                                            <button 
                                                onClick={() => addToCart(item)}
                                                className="btn-primary" 
                                                style={{width: '100%', fontSize: '0.9rem', padding: '8px'}}
                                            >
                                                Add to Cart
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Browse Categories Section */}
                        <div className="card" id="browse-categories">
                            <h2 className="section-title">Browse Categories</h2>
                            <div className="product-grid">
                                {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((cat, index) => (
                                    <div className="product-card" key={index} style={{textAlign: 'center', padding: '16px'}}>
                                        {cat.icon ? (
                                            <img src={cat.icon.startsWith('http') ? cat.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${cat.icon}`} 
                                                 alt={cat.name} 
                                                 style={{width: '60px', height: '60px', objectFit: 'contain', margin: '0 auto 12px'}} />
                                        ) : (
                                            <div style={{width: '60px', height: '60px', background: '#eee', borderRadius: '50%', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: 'var(--primary)'}}>
                                                {(cat.name || 'C').charAt(0)}
                                            </div>
                                        )}
                                        <h3 style={{fontSize: '1rem', fontWeight: 'bold', marginBottom: '12px'}}>{cat.name}</h3>
                                        <div style={{display: 'flex', gap: '8px'}}>
                                            <a href={`tel:${get_data.mobile}`} className="btn-primary" style={{flex: 1, padding: '6px', fontSize: '0.8rem', background: 'transparent', color: 'var(--text-dark)', border: '1px solid var(--border)', textDecoration: 'none'}}>Call</a>
                                            <a href="#contact" className="btn-primary" style={{flex: 1, padding: '6px', fontSize: '0.8rem', textDecoration: 'none'}}>Enquiry</a>
                                        </div>
                                    </div>
                                )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                            </div>
                        </div>
                    </div>

                    <div className="right-col">
                        <div className="card sticky" style={{top: '20px'}}>
                            <h2 className="section-title">Store Details</h2>
                            <div style={{marginBottom: '16px'}}>
                                <p><strong>Owner:</strong> {get_data.first_name}</p>
                                <p><strong>Mobile:</strong> {get_data.mobile}</p>
                                <p><strong>Email:</strong> {get_data.email}</p>
                            </div>
                            <hr style={{borderColor: '#eee', margin: '20px 0'}} />
                            <div style={{display: 'flex', gap: '10px', justifyContent: 'center'}}>
                                <a href={`https://wa.me/${get_data.mobile}`} target="_blank" rel="noreferrer" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px', textDecoration: 'none', color: '#333'}}>
                                    <img src="/assets/images/images/whatsapp-logo.png" alt="WhatsApp" style={{width: '32px'}} />
                                    <span style={{fontSize: '0.8rem'}}>WhatsApp</span>
                                </a>
                            </div>
                        </div>

                         <div className="card">
                            <h2 className="section-title">Ratings</h2>
                            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                <span style={{fontSize: '3rem', fontWeight: 'bold', color: 'var(--primary)'}}>{get_data.ratings_average || 'N/A'}</span>
                                <div>
                                    <img src="/assets/images/images/Star.png" alt="Star" style={{width: '20px'}} />
                                    <p style={{fontSize: '0.9rem', color: '#666'}}>{get_data.rating_count ? `${get_data.rating_count} Reviews` : 'No reviews yet'}</p>
                                </div>
                            </div>
                         </div>
                    </div>
                </div>
            </div>

            <Footer />
            
            <div style={{
                position: 'fixed', 
                bottom: 0, 
                left: 0, 
                right: 0, 
                background: 'white', 
                boxShadow: '0 -4px 10px rgba(0,0,0,0.1)', 
                padding: '16px', 
                zIndex: 1000,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div>
                    <h3 style={{margin: 0, fontSize: '1.2rem'}}>{get_data.service_name}</h3>
                    <p style={{margin: 0, fontSize: '0.9rem', color: '#666'}}>Opens at 09:00 AM</p>
                </div>
                <div style={{display: 'flex', gap: '10px'}}>
                     <a href={`tel:${get_data.mobile}`} className="btn-primary" style={{textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <img src="/assets/images/images/book-now.png" alt="" style={{width: '20px', filter: 'brightness(0) invert(1)'}} />
                        Book Now
                     </a>
                </div>
            </div>
            <div style={{height: '80px'}}></div>
        </>
    )
}
export default Firsttheme
